import { acceptNumberValue } from '../../field-viewer/shared-normalizers';
export const numberInputViewer = {
    normalizeLoadedValue: acceptNumberValue
};

//# sourceMappingURL=definition-viewer.js.map